import { MapboxPlaceObject } from '../../types/mapbox/MapboxPlaceObject';
import { isAddress } from './isAddress';
import { isNeighborhood } from './isNeighborhood';
import { isPostcode } from './isPostcode';
import { PlaceType } from '../../types/PlaceType';
import { isLocality } from './isLocality';
import { isPlace } from './isPlace';

export default function getPlaceType(
  mapboxPlaceObject: MapboxPlaceObject,
): PlaceType {
  if (isAddress(mapboxPlaceObject)) {
    return PlaceType.Address;
  } else if (isNeighborhood(mapboxPlaceObject)) {
    return PlaceType.Neighborhood;
  } else if (isLocality(mapboxPlaceObject)) {
    return PlaceType.Locality;
  } else if (isPlace(mapboxPlaceObject)) {
    return PlaceType.City;
  } else if (isPostcode(mapboxPlaceObject)) {
    return PlaceType.Postcode;
  } else {
    return PlaceType.Place;
  }
}
